import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";
import { IconButtonActionType } from "interface/index";
import { ColumnButtonProps } from "ui/grid/GridPage";

export const registrationOverviewGridColumns = ({
	onViewLandingNote,
	onViewSalesNote,
}: {
	onViewLandingNote?: (data: any) => void;
	onViewSalesNote?: (data: any) => void;
}) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "registrationId",
			title: t("NumberShort"),
			width: "110px",
			headerClassName: "no-border",
		},
		{
			field: "registrationTime",
			title: t("RegistrationDate"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "landingTime",
			title: t("LandingDate"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.landingTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "110px",
			headerClassName: "no-border",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			headerClassName: "no-border",
		},
		{
			field: "species",
			title: t("Species"),
			width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "catchField",
			title: t("CatchField"),
			width: "90px",
			headerClassName: "no-border",
		},
		{
			field: "netLiveWeightKg",
			title: t("Quantity"),
			width: "120px",
			headerClassName: "no-border",
			headerCell: (props) => (
				<NumericalHeader {...props} title={t("Quantity")} />
			),
			cells: {
				data: (props) => (
					<NumericalCell {...props} field="netLiveWeightKg" format="# ##0.00" />
				),
			},
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			width: "160px",
			headerClassName: "no-border",
		},
	];

	return [...gridItems];
};

export const lastColumItems = ({
	onLanding,
	onSales,
}: {
	onLanding?: (data: any) => void;
	onSales?: (data: any) => void;
}) => {
	const items: any[] = [
		{
			// iconName: ICON_NAMES.CheckboxBlack,
			title: `FD ${t("LandingNotes")}`,
			alwaysShow: true,
			text: "L",
			handler: (prop: any) => {
				// const colItem: ColumnButtonProps  = {
				const colItem: any = {
					// iconName: itemAlreadyChecked(prop.dataItem.noteNumber)
					// 	? ICON_NAMES.Checkbox
					// 	: ICON_NAMES.CheckboxBlack,
					style: {
						// opacity: handleCanCheck(prop.dataItem.noteStatusId) ? 1 : 0.2,
						// color: "black",
					},
					// alwaysShow: prop.dataItem.numberOfSalesNotes > 0,
					// iconName: ICON_NAMES.CheckboxBlack,
				};

				colItem.onclick = () => {
					onLanding?.(prop.dataItem);
				};
				return colItem;
			},
		},
		{
			// iconName: ICON_NAMES.CheckboxBlack,
			title: `FD ${t("SalesNotes")}`,
			alwaysShow: true,
			text: "S",
			handler: (prop: any) => {
				// const colItem: ColumnButtonProps  = {
				const colItem: any = {
					// iconName:

					style: {
						// opacity: handleCanCheck(prop.dataItem.noteStatusId) ? 1 : 0.2,
						// color: "black",
					},
					// alwaysShow: prop.dataItem.numberOfSalesNotes > 0,
					// iconName: ICON_NAMES.CheckboxBlack,
				};

				colItem.onclick = () => {
					onSales?.(prop.dataItem);
				};
				return colItem;
			},
		},
	];

	return items;
};
